import { Avatar, styled } from "@mui/material"

export const StyledAvatar = styled(Avatar)({
  height: 50,
  width: 50
})
